<div
  id="pageTitle"
  class="pageTitle pt-2 pb-2"
  [ngClass]="{ 'mb-3': addMarginBottom, 'has-bottom-border': addMarginBottom }"
  #pageTitle
>
  @if ({ value: desktop$ | async }; as isDesktop) {
    @if (siteConfig$ | async; as siteConfig) {
      @if (isDesktop.value && !siteConfig.ngConfig.skinName) {
        <!-- Desktop Only -->
        <div class="d-flex">
          <div class="d-flex me-3 ms-3 flex-grow-1 align-items-center">
            @if (titleIcon) {
              @if ((profilePicture || avatarInitals) && currentMeetService.meet?.hasProfilePics) {
                <div
                  [ngClass]="{ 'title-profile-pictures': profilePicture, 'title-icon-side-by-side': !profilePicture }"
                >
                  <img
                    class="title-team-logo"
                    [ngClass]="{
                      rounded: titleIcon.indexOf('static.') === -1,
                      'title-team-logo': profilePicture,
                      'title-icon-left': !profilePicture,
                    }"
                    [src]="titleIcon"
                  />
                  @if (profilePicture) {
                    <img class="title-profile-picture" [src]="profilePicture" />
                  } @else {
                    <div class="title-icon-right avatar-initial">{{ avatarInitals }}</div>
                  }
                </div>
              } @else {
                <div class="title-icon me-3 flex-grow-0" style="flex-basis: 37px">
                  <img [src]="titleIcon" />
                </div>
              }
            }
            <div class="title-text text-truncate flex-grow-1">
              <div class="title">
                @if (displayTitle) {
                  {{ displayTitle }}
                } @else {
                  &nbsp;&nbsp;
                }
              </div>
              @if (displaySubtitle) {
                <div class="subtitle">
                  {{ displaySubtitle + (eventDate && currentMeetService.meet && isDesktop.value ? ' | ' : '') }}
                  @if (eventDate && currentMeetService.meet && isDesktop.value) {
                    <app-event-date
                      [meetDates]="currentMeetService.meet.meetDates"
                      [date]="eventDate"
                      [heatDates]="heatDates"
                    ></app-event-date>
                  }
                </div>
              }
            </div>
          </div>
          <div class="icons flex-grow-0 me-3 gap-3">
            @if (dataContext) {
              @if (showFollow) {
                <app-follow-button [dataContext]="dataContext"></app-follow-button>
              }
            }
            <div>
              @if (showShare) {
                <fa-icon (click)="share()" [icon]="environment.icons.share" [fixedWidth]="true"></fa-icon>
              }
            </div>
          </div>
        </div>
      } @else if (
        (!siteConfig.ngConfig.primarySite || siteConfig.ngConfig.skinName) &&
        (siteConfig.ngConfig.headerImageDarkModeUrl || siteConfig.ngConfig.headerImageUrl)
      ) {
        <!-- There is a logo above the title -->
        <div class="d-flex mb-1 align-items-center">
          <div class="titles flex-grow-1 ms-3">
            <div class="d-flex justify-content-left">
              <a class="enterprise-logo" [routerLink]="siteConfig.ngConfig.skinName ? '/meets/' + meet?.id : '/'">
                @if ({ value: isDarkMode$ | async }; as isDarkMode) {
                  @if (isDarkMode.value) {
                    <img [src]="siteConfig.ngConfig.headerImageDarkModeUrl" [alt]="siteConfig.ngConfig.siteName" />
                  } @else {
                    <img [src]="siteConfig.ngConfig.headerImageUrl" [alt]="siteConfig.ngConfig.siteName" />
                  }
                }
              </a>
            </div>
          </div>
          <div class="icons flex-grow-0 me-3 gap-3">
            @if (dataContext && showFollow) {
              <app-follow-button [dataContext]="dataContext"></app-follow-button>
            }
            <div>
              @if (showShare) {
                <fa-icon (click)="share()" [icon]="environment.icons.share" [fixedWidth]="true"></fa-icon>
              }
            </div>
          </div>
        </div>
        <div class="d-flex me-3 ms-3 align-items-center">
          @if (titleIcon) {
            @if ((profilePicture || avatarInitals) && currentMeetService.meet?.hasProfilePics) {
              <div [ngClass]="{ 'title-profile-pictures': profilePicture, 'title-icon-side-by-side': !profilePicture }">
                <img
                  class="title-team-logo"
                  [ngClass]="{
                    rounded: titleIcon.indexOf('static.') === -1,
                    'title-team-logo': profilePicture,
                    'title-icon-left': !profilePicture,
                  }"
                  [src]="titleIcon"
                />
                @if (profilePicture) {
                  <img class="title-profile-picture" [src]="profilePicture" />
                } @else {
                  <div class="title-icon-right avatar-initial">{{ avatarInitals }}</div>
                }
              </div>
            } @else {
              <div class="title-icon me-3 flex-grow-0" style="flex-basis: 37px">
                <img [src]="titleIcon" />
              </div>
            }
          }

          <div class="title-text text-truncate flex-grow-1">
            <div class="title">
              @if (displayTitle) {
                {{ displayTitle }}
              } @else {
                &nbsp;&nbsp;
              }
            </div>
            @if (displaySubtitle) {
              <div class="subtitle">
                {{ displaySubtitle + (eventDate && currentMeetService.meet && isDesktop.value ? ' | ' : '') }}
                @if (eventDate && currentMeetService.meet && isDesktop.value) {
                  <app-event-date [meetDates]="currentMeetService.meet.meetDates" [date]="eventDate"></app-event-date>
                }
              </div>
            }
          </div>
        </div>
      } @else {
        <!-- No logo: text only -->
        <div class="d-flex ms-3 align-items-center">
          <div class="w-100">
            @if (titleIcon) {
              @if ((profilePicture || avatarInitals) && currentMeetService.meet?.hasProfilePics) {
                <div
                  [ngClass]="{ 'title-profile-pictures': profilePicture, 'title-icon-side-by-side': !profilePicture }"
                >
                  <img
                    class="title-team-logo"
                    [ngClass]="{
                      rounded: titleIcon.indexOf('static.') === -1,
                      'title-team-logo': profilePicture,
                      'title-icon-left': !profilePicture,
                    }"
                    [src]="titleIcon"
                  />
                  @if (profilePicture) {
                    <img class="title-profile-picture" [src]="profilePicture" />
                  } @else {
                    <div class="title-icon-right avatar-initial">{{ avatarInitals }}</div>
                  }
                </div>
              } @else {
                <div class="title-icon me-3 flex-grow-0" style="flex-basis: 37px">
                  <img [src]="titleIcon" />
                </div>
              }
            }

            <div class="title-text text-truncate flex-grow-1">
              <div class="title">
                @if (displayTitle) {
                  {{ displayTitle }}
                } @else {
                  &nbsp;&nbsp;
                }
              </div>
            </div>
          </div>

          <div class="icons me-3 gap-2 align-self-start">
            @if (dataContext && showFollow) {
              <app-follow-button [dataContext]="dataContext"></app-follow-button>
            }
            <div>
              @if (showShare) {
                <fa-icon (click)="share()" [icon]="environment.icons.share" [fixedWidth]="true"></fa-icon>
              }
            </div>
          </div>
        </div>
        @if (displaySubtitle) {
          <div class="d-flex ms-3">
            <div class="w-100">
              <div class="subtitle">
                {{ displaySubtitle + (eventDate && currentMeetService.meet && isDesktop.value ? ' | ' : '') }}
                @if (eventDate && currentMeetService.meet && isDesktop.value) {
                  <app-event-date [meetDates]="currentMeetService.meet.meetDates" [date]="eventDate"></app-event-date>
                }
              </div>
            </div>
          </div>
        }
      }
    }
  }
</div>
